import React from 'react'
import { App } from './App'

function Voting() {
  return (
    <App
      columns={[
        { name: 'unranked', displayName: 'Unranked Issues', position: 'left' },
        { name: 'ranked', displayName: 'Ranked Issues', position: 'right' },
      ]}
      page="app"
    />
  )
}

export default Voting
